// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"293":"60c236cd","932":"7a597bb4"}[chunkId] + ".js";
};